<loader-container
  [loader]="loader"
  [options]="{
    contentTemplate: preview
  }"
  (loaded)="template = $event"
></loader-container>

<ng-template #preview>
  <div *ngIf="template">
    <data-preview
      [item]="template"
      [options]="{
        properties: {
        'createdBy': { heading: 'Created by', order: 51, valueRenderTemplate: propertyOwner },
        'id': { heading: 'UID', order: 1 },
        'name': { heading: 'Name', order: 2 },
        'description': { heading: 'Description', order: 3 },
        'messages': { hidden: true }
        }
      }"
    ></data-preview>
    <actions-container *ngIf="!hideActions" [ngClass]="'pb-4'">
      <back-button></back-button>
      <manage-button
        [isExisting]="true"
        [routerLink]="['../../manage', templateId!]">
      </manage-button>
      <delete-button
        [routerLink]="['../../delete', templateId!]">
      </delete-button>
    </actions-container>
  </div>
</ng-template>

<div *ngIf="template && template.messages">
  <quick-preview-panel [heading]="'Messages'" color="primary" [collapsable]="true">
    <data-table
      [columnOptions]="{
      '$$raw': { hidden: true },
      'role': { heading: 'Role', order: 1 },
      'message': { heading: 'Message', order: 2, renderTemplate: cellMessage },
    }"
      [items]="template.messages">
    </data-table>
  </quick-preview-panel>
</div>

<ng-template #cellMessage let-cellItem=cellItem>
  <div class="fw-light font-size-12">{{cellItem}}</div>
</ng-template>

<ng-template #propertyOwner let-propertyValue=propertyValue>
  <user-id-tag
    [userId]="propertyValue"
  ></user-id-tag>
</ng-template>
